import { render } from "./EditProduit.vue?vue&type=template&id=c4f7abbc&scoped=true&ts=true"
import script from "./EditProduit.vue?vue&type=script&lang=ts"
export * from "./EditProduit.vue?vue&type=script&lang=ts"

import "./EditProduit.vue?vue&type=style&index=0&id=c4f7abbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f7abbc"]])

export default __exports__